import React, { Component } from 'react';

export default class Filter extends Component {
  render() {
    const { handleFilterSection, onSubmit } = this.props;
    return (
      <div>
        <div className="modal-bg" />
        <div className="modal">
          <div className="short-by">
            {/* Header */}
            <div className="head-general bg-gray with-back">
              <a href="javascript: void(0)" onClick={handleFilterSection} />
              <h4>Sort By</h4>
              <a
                href="javascript: void(0)"
                onClick={handleFilterSection}
                className="close"
              >
                <icon className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="row center-sm">
                <div className="col-sm-6">
                  <div className="list">
                    <ul>
                      <li onClick={() => onSubmit('REWARD')}>Reward</li>
                      <li onClick={() => onSubmit('DISTANCE')}>Distance</li>
                      <li onClick={() => onSubmit('SCORE')}>Rating</li>
                      <li onClick={() => onSubmit('NAME')}>A-Z</li>
                    </ul>
                  </div>

                  <div className="use-buttons">
                    <button
                      className="btn btn-gray"
                      onClick={handleFilterSection}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                {/* .col-sm-6 */}
              </div>
              {/* .row */}
            </div>
            {/* .modal-body */}
          </div>
          {/* short-by */}
        </div>
        {/* .modal */}
      </div>
    );
  }
}
